import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sectionTitle: {
    defaultMessage: 'Fraud Indicators ({count})',
    description: 'Fraud indicators section title',
    id: 'aaWplG',
  },
  sectionAriaLabel: {
    defaultMessage: 'Fraud Indicators',
    description: 'Aria label for fraud indicators section',
    id: 'NEKhg2',
  },
});
